import { ApolloClient } from "@apollo/client"

export function refreshHomeRegistrations(
  client: ApolloClient<object>,
  userId: number
) {
  return client.refetchQueries({
    updateCache(cache) {
      // Home may be unmounted while browsing the Store. Refetching alone
      // misses that query, so discard its stale list before returning Home.
      cache.evict({
        id: cache.identify({ __typename: "User", id: userId }),
        fieldName: "registrations"
      })
    }
  })
}
